import { useEffect, useState } from "react";
import "../../../pages/navbar.css";
import { Auth } from "aws-amplify";
import { useNavigate, useLocation } from "react-router-dom";
import Message from "../../Message";
import passwordValidator from "password-validator";
import {
  Box,
  Container,
  Divider,
  FormControl,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import "./PasswordResetForm.css";
import useProfileStore from "../../../store/ProfileStore";
import useAuthStore from "../../../store/AuthStore";
import {
  ChangedBy,
  CreateProfileChangeRecord,
} from "../../../queries/CreateProfileChangeRecord";
import { fetchQuery } from "../../../functions/misc";
import { GetLatestPasswordChangeRecord } from "../../../queries/GetLatestPasswordChangeRecord";
import { userProfileData } from "../../../Common/profileInfo";
import { Breadcrumb, Button } from "react-bootstrap";
import CircularProgress from "@mui/material/CircularProgress";
import Footer from "../../footer";
import "../../../pages/navbar.css";
import AppBreadcrumbs from "../../AppBreadCrumbs";

function PasswordResetForm() {
  const navigate = useNavigate();
  useLocation();
  const [currentStep, setCurrentStep] = useState(0);
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isPartnerProfile, setIsPartnerProfile] = useState(false)
  const [lastUpdated, setLastUpdated] = useState("");
  const [passwordFields, setPasswordFields] = useState({
    newPassword: "",
    reNewPassword: "",
  });
  const [validate, setValidate] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [rePasswordError, setRePasswordError] = useState("");
  const [samePasswordError, setSamePasswordError] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [limitExceed, setLimitExceeded] = useState(false);
  const { primaryProfile } = useProfileStore();
  const { cognitoAttributes, setCognitoAttributes, setResettingPassword } = useAuthStore();

  const schema = new passwordValidator();
  schema
    .is()
    .min(8)
    .has()
    .uppercase()
    .has()
    .lowercase()
    .has()
    .digits()
    .has()
    .symbols()
    .has()
    .not()
    .spaces();
  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const res = await Auth.currentAuthenticatedUser();

    setEmail(res.username);
    setIsPartnerProfile(res.attributes["custom:Group"] !== "profile")
  };

  const getLatUpdatedDate = async () => {
    const profileId = await userProfileData();
    const getLatestChangeDate = await fetchQuery(
      { ProfileId: profileId },
      GetLatestPasswordChangeRecord
    );
    setLastUpdated(getLatestChangeDate.RecordDate);
  };

  useEffect(() => {
    getLatUpdatedDate();
  }, []);

  const handlePasswordFields = (event: any) => {
    setPasswordFields({
      ...passwordFields,
      [event.target.name]: event.target.value,
    });
  };

  const resetPassword = async () => {
    setShowSpinner(true);
    setDisableSubmit(true);
    setResettingPassword(true);
    setCognitoAttributes({
      ...cognitoAttributes,
      Email: email,
    });
    try {
      await Auth.forgotPassword(email);
      setTimeout(() => {
        navigate('/login');
      }, 1000);
    } catch (error: any) {
      let code = error.code;
      if (code === "LimitExceededException") {
        setDisableSubmit(true);
        setShowSpinner(false);
        setLimitExceeded(true);
      }
      console.log("error:", error);
    }
  };


  const validateCode = () => {
    if (!code) {
      setValidate("Code Is Mandartory");
      return;
    }
    setCurrentStep(2);
  };

  const submitPassword = async () => {
    try {
      if (!passwordFields.newPassword || !passwordFields.reNewPassword) {
        if (!passwordFields.newPassword) {
          setPasswordError("Password is Mandatory");
        }
        if (!passwordFields.reNewPassword) {
          setRePasswordError("Password is Mandatory");
        }
        return;
      }

      if (passwordFields.newPassword !== passwordFields.reNewPassword) {
        setSamePasswordError("Both the passwords didn't match");
        setTimeout(() => {
          setSamePasswordError("");
        }, 5000);
        return;
      }

      if (!schema.validate(passwordFields.newPassword)) {
        setSamePasswordError(
          "Password must have minimum of 8 characters and contain 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character"
        );
        setTimeout(() => {
          setSamePasswordError("");
        }, 5000);
        return;
      }

      await Auth.forgotPasswordSubmit(
        email.toLowerCase(),
        code,
        passwordFields.newPassword
      );

      await Auth.signIn(email.toLowerCase(), passwordFields.newPassword);
      setSuccess("Password Updated Successfully");
      const variables = {
        ProfileId: primaryProfile?.Id,
        ChangedField: "Password",
        ChangedBy: ChangedBy.Profile,
      };
      await fetchQuery(variables, CreateProfileChangeRecord);
      getLatUpdatedDate();
      setError("");
      setPasswordFields({
        newPassword: "",
        reNewPassword: "",
      });
      setCode("");

      setTimeout(() => {
        setSuccess("");
      }, 3000);

      setCurrentStep(0);
    } catch (err: any) {
      const code: any = err.code;

      switch (code) {
        case "CodeMismatchException":
          setError("Invalid verification code provided.");
          break;

        case "InvalidPasswordException":
          setError("New password does not meet the required criteria.");
          break;

        default:
          setError("An error occurred. Please try again.");
          break;
      }

      console.error("Error:", err);
    }
  };

  return (
    <div className="page-container">
      <Container sx={{ mb: 5 }}>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              width: "80%",
            }}
          >
            <Box className="headerTitleBox">
              <h1 className="headerTitle">
                Change Password
              </h1>
              <AppBreadcrumbs
                items={[
                  {
                    label: 'Home',
                    onClick: () => navigate( isPartnerProfile?"/partner-dashboard"  : "/dashboard/tax-shield/enrollment"),
                  },
                  { label: 'Account Settings' ,  onClick: () => isPartnerProfile && navigate("/partner/settings/profile")}
                  ,
                  { label: 'Security' },
                ]}

              />
            </Box>
            <Box className="formContainerBox">
              {currentStep === 2 && (
                <Box sx={{ py: 3, px: { xs: 2, sm: 4, md: 4, lg: 4 } }}>
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "26px",
                        }}
                      >
                        Enter New Password
                      </Typography>
                    </Box>
                    <Box sx={{ py: "10px" }}>
                      <Typography
                        sx={{
                          fontSize: "12px",
                          fontWeight: 400,
                          lineHeight: "20px",
                          letterSpacing: "0.4000000059604645px",
                          textAlign: "left",
                          color: "#000000",
                        }}
                      >
                        A request has been made to reset your password. If you
                        made this request, please enter the new password.
                        Password must have minimum of 8 characters and contain 1
                        uppercase letter, 1 lowercase letter, 1 number and 1
                        special character
                      </Typography>
                    </Box>
                    <Box sx={{ py: "10px" }}>
                      <TextField
                        label="New Password"
                        type="password"
                        fullWidth
                        value={passwordFields.newPassword}
                        name="newPassword"
                        onChange={handlePasswordFields}
                      />
                    </Box>
                    <Box sx={{ py: "10px" }}>
                      <TextField
                        label="Verify New Password"
                        type="password"
                        fullWidth
                        value={passwordFields.reNewPassword}
                        name="reNewPassword"
                        onChange={handlePasswordFields}
                      />
                    </Box>
                  </Box>
                  <Divider sx={{ py: "8px" }} />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      width: "60%",
                      px: "1.25rem",
                    }}
                  >
                    {success && (
                      <Message type="success" message={success}></Message>
                    )}
                    {error && <Message type="error" message={error}></Message>}
                    {validate && (
                      <Message type="error" message={validate}></Message>
                    )}
                    {passwordError && (
                      <Message type="error" message={passwordError}></Message>
                    )}

                    {rePasswordError && (
                      <Message type="error" message={rePasswordError}></Message>
                    )}
                    {samePasswordError && (
                      <Message type="error" message={samePasswordError}></Message>
                    )}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      padding: "8px 8px 16px 8px",
                      gap: "8px",
                    }}
                  >
                    <button
                      className="cancel-button"
                      onClick={() => navigate(isPartnerProfile?"/partner-dashboard"  : "/dashboard/tax-shield/enrollment")}
                    >
                      Cancel
                    </button>
                    <button
                      className="save-changes-button"
                      disabled={true}
                      onClick={submitPassword}
                    >
                      Reset Password
                    </button>
                  </Box>
                </Box>
              )}

              {currentStep === 1 && (
                <>
                  <Box sx={{ padding: "0px 24px 16px 24px" }}>
                    <Box sx={{ padding: "32px 0px 0px 0px", gap: "9px" }}>
                      <Typography
                        sx={{
                          fontWeight: 500,
                          fontSize: "18px",
                          lineHeight: "26.1px",
                        }}
                      >
                        To Continue, Please enter the passcode sent to your
                        email {email}
                      </Typography>

                      <Box
                        sx={{
                          fontSize: "12px",
                          fontWeight: 400,
                          lineHeight: "20px",
                          marginTop: 1,
                        }}
                      >
                        Request a New Passcode
                        <span
                          style={{
                            cursor: "pointer",
                            paddingLeft: "5px",
                            color: "#1D89D2",
                            textDecoration: "underline",
                          }}
                          onClick={resetPassword}
                        >
                          click here
                        </span>
                      </Box>

                      <FormControl fullWidth sx={{ marginTop: 3 }}>
                        <InputLabel shrink>
                          Please Enter the Passcode to continue
                        </InputLabel>
                        <TextField
                          placeholder=""
                          value={code}
                          onChange={(e) => {
                            setCode(e.target.value);
                            setValidate("");
                          }}
                          sx={{ my: "8px" }}
                          variant="outlined"
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <Box
                    width={"100%"}
                    display={"flex"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                    padding={"8px 16px 16px 16px"}
                    gap={"8px"}
                  >
                    <button
                      className="cancel-button"
                      onClick={() => navigate(isPartnerProfile?"/partner-dashboard"  : "/dashboard/tax-shield/enrollment")}
                    >
                      Cancel
                    </button>
                    <button
                      className="save-changes-button"
                      onClick={validateCode}
                    >
                      Submit Passcode
                    </button>
                  </Box>
                </>
              )}

              {currentStep === 0 && (
                <Box sx={{ padding: "2rem" }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "18px",
                      lineHeight: "26px",
                    }}
                  >
                    Your password was last changed on {lastUpdated}.
                  </Typography>

                  <Typography className='content-text mt-2 mb-3' variant='body2'>
                    If you want to change your password, just click the "Change Password" button below. We'll send you an email with simple instructions to guide you.
                  </Typography>

                  {limitExceed && (
                    <Message message={"Attempt limit exceeded, please try again after 15 minutes."} type="error"></Message>
                  )}

                  <Box
                    width={"100%"}
                    display={"flex"}
                    className='mt-2'
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                  >
                    <button
                      className="cancel-button"
                      onClick={() => navigate(isPartnerProfile?"/partner-dashboard"   : "/dashboard/tax-shield/enrollment")}
                    >
                      Cancel
                    </button>
                    <Button variant="primary p-2" disabled={disableSubmit} onClick={resetPassword}>
                      {showSpinner ?
                        <>
                          <CircularProgress
                            size={20}
                            thickness={4}
                            sx={{ color: 'white', marginRight: '4px' }}
                            role="status"
                            aria-hidden="true"
                          />
                          Change Password
                        </>
                        :
                        "Change Password"
                      }
                    </Button>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
      <Footer />
    </div>
  );
}

export default PasswordResetForm;
